var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-notification-wrap" }, [
    _c(
      "div",
      { staticClass: "notification-toolbar" },
      [
        _c(
          "el-button",
          {
            attrs: { type: "primary", icon: "el-icon-plus" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.addNotification($event)
              }
            }
          },
          [_vm._v(" Add Notification  ")]
        ),
        _vm._v(" "),
        _vm.notifications.length >= 1
          ? _c(
              "el-button",
              {
                attrs: { type: "success", icon: "el-icon-check" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.saveNotification($event)
                  }
                }
              },
              [_vm._v(" Save Notifications")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.editing !== false
          ? _c(
              "el-button",
              {
                attrs: {
                  type: "info",
                  icon: "el-icon-arrow-left",
                  size: "small"
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.back($event)
                  }
                }
              },
              [_vm._v(" Back ")]
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-notifications" },
      [
        !_vm.editing
          ? _c(
              "el-card",
              {
                staticClass: "notification-table-card",
                attrs: { shadow: "hover" }
              },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.notifications, border: "", stripe: "" }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "active", label: "Status", width: "180" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.active
                                  ? _c("span", { staticClass: "mr-3" }, [
                                      _vm._v(" Enabled ")
                                    ])
                                  : _c(
                                      "span",
                                      { staticClass: "mr-3 text-danger" },
                                      [_vm._v(" Disabled ")]
                                    ),
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(scope.row.active == 1) +
                                    "\n                    "
                                ),
                                _c("el-switch", {
                                  attrs: { width: 40 },
                                  on: {
                                    change: function(val) {
                                      return _vm.toggelNotification(
                                        scope.$index,
                                        val
                                      )
                                    }
                                  },
                                  model: {
                                    value: scope.row.active,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "active", $$v)
                                    },
                                    expression: "scope.row.active"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2003761732
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "name", label: "Name", width: "180" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "subject", label: "Subject", width: "480" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Actions" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    type: "primary",
                                    icon: "el-icon-edit"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.editNotification(scope.$index)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    icon: "el-icon-copy-document"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.duplicateNotification(
                                        scope.$index
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _vm.notifications.length > 1
                                  ? _c("el-button", {
                                      attrs: {
                                        size: "mini",
                                        type: "danger",
                                        icon: "el-icon-delete"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteNotification(
                                            scope.$index
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        212069737
                      )
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.notifications[_vm.editingIndex] && _vm.editing
          ? _c(
              "div",
              [
                _c(
                  "el-form",
                  {
                    model: {
                      value: _vm.notifications[_vm.editingIndex],
                      callback: function($$v) {
                        _vm.$set(_vm.notifications, _vm.editingIndex, $$v)
                      },
                      expression: "notifications[editingIndex]"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-fields" },
                      [
                        _c(
                          "div",
                          { staticClass: "notification-head" },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Notification Title" } },
                              [
                                _c("el-input", {
                                  model: {
                                    value:
                                      _vm.notifications[_vm.editingIndex].name,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.notifications[_vm.editingIndex],
                                        "name",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "notifications[editingIndex].name"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "notification-row notification-field"
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "contactum-label",
                                attrs: { for: "notification-title" }
                              },
                              [_vm._v(_vm._s("Type"))]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "Select Type" },
                                model: {
                                  value:
                                    _vm.notifications[_vm.editingIndex].type,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.notifications[_vm.editingIndex],
                                      "type",
                                      $$v
                                    )
                                  },
                                  expression: "notifications[editingIndex].type"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "Email Notification",
                                    value: "email"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.notifications[_vm.editingIndex].type == "email"
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "notification-row notification-field"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "contactum-label",
                                      attrs: { for: "notification-title" }
                                    },
                                    [_vm._v(_vm._s("To"))]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    model: {
                                      value:
                                        _vm.notifications[_vm.editingIndex].to,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.notifications[_vm.editingIndex],
                                          "to",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "notifications[editingIndex].to"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("merge_tags", {
                                    attrs: { field: "to" },
                                    on: { insert: _vm.insertValue }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "notification-row notification-field"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "contactum-label",
                                      attrs: { for: "notification-title" }
                                    },
                                    [_vm._v(_vm._s("Reply To"))]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    model: {
                                      value:
                                        _vm.notifications[_vm.editingIndex]
                                          .replyTo,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.notifications[_vm.editingIndex],
                                          "replyTo",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "notifications[editingIndex].replyTo"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("merge_tags", {
                                    attrs: { field: "replyTo" },
                                    on: { insert: _vm.insertValue }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "notification-row notification-field"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "contactum-label",
                                      attrs: { for: "notification-title" }
                                    },
                                    [_vm._v(_vm._s("Subject"))]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    model: {
                                      value:
                                        _vm.notifications[_vm.editingIndex]
                                          .subject,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.notifications[_vm.editingIndex],
                                          "subject",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "notifications[editingIndex].subject"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("merge_tags", {
                                    attrs: { field: "subject" },
                                    on: { insert: _vm.insertValue }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "notification-row notification-field"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "contactum-label",
                                      attrs: { for: "notification-title" }
                                    },
                                    [_vm._v(_vm._s("Email Message"))]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    attrs: { type: "textarea" },
                                    model: {
                                      value:
                                        _vm.notifications[_vm.editingIndex]
                                          .message,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.notifications[_vm.editingIndex],
                                          "message",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "notifications[editingIndex].message"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("merge_tags", {
                                    attrs: { field: "message" },
                                    on: { insert: _vm.insertValue }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "notification-row notification-field"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "contactum-label",
                                      attrs: { for: "notification-title" }
                                    },
                                    [_vm._v(" From Name ")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    model: {
                                      value:
                                        _vm.notifications[_vm.editingIndex]
                                          .fromName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.notifications[_vm.editingIndex],
                                          "fromName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "notifications[editingIndex].fromName"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("merge_tags", {
                                    attrs: { field: "fromName" },
                                    on: { insert: _vm.insertValue }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "notification-row notification-field"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "contactum-label",
                                      attrs: { for: "notification-title" }
                                    },
                                    [_vm._v(" From Address ")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    attrs: { type: "email" },
                                    model: {
                                      value:
                                        _vm.notifications[_vm.editingIndex]
                                          .fromAddress,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.notifications[_vm.editingIndex],
                                          "fromAddress",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "notifications[editingIndex].fromAddress"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("merge_tags", {
                                    attrs: {
                                      filter: "email_address",
                                      field: "fromAddress"
                                    },
                                    on: { insert: _vm.insertValue }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "notification-row notification-field"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "contactum-label",
                                      attrs: { for: "notification-title" }
                                    },
                                    [_vm._v(" CC ")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    attrs: { type: "email", name: "" },
                                    model: {
                                      value:
                                        _vm.notifications[_vm.editingIndex].cc,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.notifications[_vm.editingIndex],
                                          "cc",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "notifications[editingIndex].cc"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "notification-row notification-field"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "contactum-label",
                                      attrs: { for: "notification-title" }
                                    },
                                    [_vm._v(" BCC ")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    attrs: { type: "email" },
                                    model: {
                                      value:
                                        _vm.notifications[_vm.editingIndex].bcc,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.notifications[_vm.editingIndex],
                                          "bcc",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "notifications[editingIndex].bcc"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer"
          },
          [
            _c(
              "el-button",
              {
                on: {
                  click: function($event) {
                    _vm.editing = false
                  }
                }
              },
              [_vm._v("Cancel")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: { click: _vm.updateNotification }
              },
              [_vm._v(" Update ")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }